type StepsProps = {
  nodes: any
  materials: any
}

const Steps = ({ nodes, materials }: StepsProps) => {
  return (
    <>
      <group name="container-step-1">
        <mesh
          name="step-1-mesh-1"
          castShadow
          receiveShadow
          geometry={nodes['step-1-mesh-1'].geometry}
          material={materials['green-flat']}
          position={[0.404, -55.079, -0.27]}
          scale={0}
        />
        <mesh
          name="step-1-mesh-2"
          castShadow
          receiveShadow
          geometry={nodes['step-1-mesh-2'].geometry}
          material={materials['green-flat']}
          position={[0.404, -55.079, -0.27]}
          scale={0}
        />
        <mesh
          name="step-1-mesh-3"
          castShadow
          receiveShadow
          geometry={nodes['step-1-mesh-3'].geometry}
          material={materials['green-flat']}
          position={[0.404, -55.079, -0.27]}
          scale={0}
        />
      </group>
      <group name="container-step-2">
        <mesh
          name="step-2-mesh-1"
          castShadow
          receiveShadow
          geometry={nodes['step-2-mesh-1'].geometry}
          material={materials['green-flat']}
          position={[2.548, -118.052, -3.821]}
          scale={0}
        />
        <mesh
          name="step-2-mesh-2"
          castShadow
          receiveShadow
          geometry={nodes['step-2-mesh-2'].geometry}
          material={materials['green-flat']}
          position={[2.548, -118.052, -3.821]}
          scale={0}
        />
        <mesh
          name="step-2-mesh-3"
          castShadow
          receiveShadow
          geometry={nodes['step-2-mesh-3'].geometry}
          material={materials['green-flat']}
          position={[2.548, -118.052, -3.821]}
          scale={0}
        />
      </group>
      <group name="container-step-3">
        <mesh
          name="step-3-mesh-1"
          castShadow
          receiveShadow
          geometry={nodes['step-3-mesh-1'].geometry}
          material={materials['green-flat']}
          position={[12.915, -149.999, 7.92]}
        />
        <mesh
          name="step-3-mesh-2"
          castShadow
          receiveShadow
          geometry={nodes['step-3-mesh-2'].geometry}
          material={materials['green-flat']}
          position={[15.324, -140.215, -3.008]}
          rotation={[0, 0, Math.PI / 4]}
        />
        <mesh
          name="step-3-mesh-3"
          castShadow
          receiveShadow
          geometry={nodes['step-3-mesh-3'].geometry}
          material={materials['green-flat']}
          position={[6.353, -150.813, -3.406]}
          rotation={[0, 0, -Math.PI / 4]}
        />
      </group>
      <group name="container-step-4">
        <mesh
          name="step-4-mesh-1"
          castShadow
          receiveShadow
          geometry={nodes['step-4-mesh-1'].geometry}
          material={materials['green-flat']}
          position={[-5.792, -214.147, -1.092]}
          scale={0}
        />
        <mesh
          name="step-4-mesh-2"
          castShadow
          receiveShadow
          geometry={nodes['step-4-mesh-2'].geometry}
          material={materials['green-flat']}
          position={[-5.792, -214.147, -1.092]}
          scale={0}
        />
        <mesh
          name="step-4-mesh-3"
          castShadow
          receiveShadow
          geometry={nodes['step-4-mesh-3'].geometry}
          material={materials['green-flat']}
          position={[-5.792, -214.147, -1.092]}
          scale={0}
        />
      </group>
      <group name="container-step-5">
        <mesh
          name="step-5-mesh-1"
          castShadow
          receiveShadow
          geometry={nodes['step-5-mesh-1'].geometry}
          material={materials['green-flat']}
          position={[-3.864, -250.627, -0.483]}
          scale={0}
        />
        <mesh
          name="step-5-mesh-2"
          castShadow
          receiveShadow
          geometry={nodes['step-5-mesh-2'].geometry}
          material={materials['green-flat']}
          position={[-3.864, -250.627, -0.483]}
          scale={0}
        />
        <mesh
          name="step-5-mesh-3"
          castShadow
          receiveShadow
          geometry={nodes['step-5-mesh-3'].geometry}
          material={materials['green-flat']}
          position={[-3.864, -250.627, -0.483]}
          scale={0}
        />
      </group>
    </>
  )
}

export default Steps
